import React from 'react';
import PropTypes from 'prop-types';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { DataValueMap } from 'Helpers/Testing';

const QuotedEmailText = ({
  open,
  quoteArray,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div
      {...DataValueMap.init('message-email-quoted-text').build()}
    >
      {quoteArray.map(quoteElement => (
        <RichTextDisplay
          content={quoteElement.outerHTML}
        />))}
    </div>
  );
};

QuotedEmailText.defaultProps = {
};

QuotedEmailText.propTypes = {
  open: PropTypes.bool.isRequired,
  quoteArray: PropTypes.array.isRequired,
};


export default QuotedEmailText;
